const logLevels = ['info', 'warn', 'error', 'debug'];

const writeLog = (logLevel, ...args) => {
  const logIndex = logLevels.indexOf(logLevel);
  const currentLogLevel = logLevels.indexOf(window.LOG_LEVEL);
  if (logIndex > 0 && currentLogLevel >= logIndex) {
    console[logLevels[logIndex]](...args);
  }
};

const logger = (logLevel, ...args) => {
  if (window.LOG_LEVEL) {
    writeLog(logLevel, ...args);
  }
};

export default logger;
